<div class="container-fluid">
    <div class="details">
      <div class="d-flex justify-content-between">
        <div>
          <div style="cursor: pointer;" (click)="selectAll()"><span>Droits d'accès sur les fontionalites</span></div>
          <label style="cursor: pointer;" (click)="selectAll()"><strong>(DA_DROITS) </strong></label><br />
          <ul>
            <div class="title">
              <div
                class="form-check"
                *ngFor="let droitItem of droit; let i = index"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  [name]="droitItem.text"
                  [id]="droitItem.text"
                  (change)="pickDroitItem()"
                  [(ngModel)]="droitItem.selected"
                  [ngModelOptions]="{standalone: true}"
                  [disabled]="!edition"
                />
                <label
                  class="form-check-label"
                  for="flexRadioDefault2"
                >
                  <span *ngIf="droitItem.text">{{
                    droitItem.text
                  }}</span></label
                ><br />
                <div
                  class="form-check"
                  *ngFor="let subItem of droitItem.children"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [name]="subItem.text"
                    [id]="subItem.text"
                    [(ngModel)]="subItem.selected"
                    [disabled]="!edition"
                    
                  />
                  <label
                    class="form-check-label"
                    for="flexRadioDefault2"
                  >
                    <span *ngIf="subItem.text">{{
                      subItem.text
                    }}</span></label
                  ><br />
                </div>
              </div>
            </div>
            <br />
          </ul>
          <br />
        </div>
      
      </div>
    </div>

</div>

